import { IOrderProduct } from "interfaces/IOrder"
import { IProductSpecs } from "interfaces/IProduct";
import { CSSProperties, useMemo, useState } from "react";

/**
 * Custom props for the product row
 */
interface Props {
    /**
     * The product of the order
     */
    product: IOrderProduct;
    /**
     * pass the quantity to the parent component
     */
    handleQuantity: (quantity: number) => void;
    /**
     * pass the Subtotal to the parent component
     */
    handleSubtotal: (subtotal: number) => void;
}

/**
 * interface needed to fetch order information on table
 */
interface IOrderItem {
    /**
     * The image of the order item
     */
    image: string;
    /**
     * The name of the item
     */
    name: string;
    /**
     * The size of the item
     */
    size: string;
    /**
     * The color name of the item
     */
    colorName: string;
    /**
     * The color of the item
     */
    color: string;
    /**
     * The unit price of the item
     */
    unit_price: number;
    /**
     * The quantity of the item
     */
    quantity: number;
    /**
     * The unit price times quantity 
     */
    total: number;
}

/**
 * The row component for the product of an order
 */
export const ProductRow = ({ 
    product,
    handleQuantity,
    handleSubtotal 
}: Props) => {
    
    const orderInformation: IOrderItem[] = useMemo(() => {
        let quantity = 0;
        let subTotal = 0;
        const colors = product.colors.reduce((acc: IOrderItem[], color) => {
            color.sizes.forEach(size => {
                let item: IOrderItem = {
                    color: color.color,
                    colorName: color.colorName,
                    image: color.images[0],
                    name: product.product_name,
                    size: size.size_name,
                    quantity: size.quantity,
                    unit_price: size.price,
                    total: size.subtotal,
                };
                quantity += Number(size.quantity);
                subTotal += Number(size.subtotal);
                acc.push(item as IOrderItem);
            });
            handleQuantity(quantity);
            handleSubtotal(subTotal);
            return acc;
        }, []);

        return colors;
    }, [product]);

    return (
        <tbody className="bg-inherit">
            {orderInformation.map(x => (
                <tr key={`Order table row ${x.name} ${x.color}`} style={{ borderColor: "#997404" }} className="bborder bg-inherit">
                    <td style={{ width: "50%" }} className="flex-column flex-grow-1 justify-content-center bg-inherit">
                        <div className="d-flex">
                            <span className="me-2 bg-inherit"><img height={54} width={54} src={x.image} /></span>
                            <div className="ms-2">
                                {product.product_name}
                                <span className="d-flex justify-content-start">
                                    <span className="me-3">Talla: {x.size}</span>
                                    <span className="ms-3 me-3">Color: {x.colorName}</span>
                                    <div className="ms-3 colorDot" style={{ background: `${x.color}`, height: "25px", width: "25px", borderRadius: "14px" }} />
                                </span>
                            </div>
                        </div>
                    </td>
                    <td className="bg-inherit text-center">${x.unit_price}</td>
                    <td className="bg-inherit text-center">{x.quantity}</td>
                    <td className="bg-inherit text-center">${x.total}</td>
                </tr>
            ))}
        </tbody>
    )
}
